export const EMPLOYEE_PROFILES_SEGMENTS = ["all", "shared", "private"] as const;

export type EmployeeProfilesSegment = (typeof EMPLOYEE_PROFILES_SEGMENTS)[number];
